import { render, staticRenderFns } from "./PosCounterHeader.vue?vue&type=template&id=f0f9fa60&scoped=true&"
import script from "./PosCounterHeader.vue?vue&type=script&lang=js&"
export * from "./PosCounterHeader.vue?vue&type=script&lang=js&"
import style0 from "./PosCounterHeader.vue?vue&type=style&index=0&id=f0f9fa60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f9fa60",
  null
  
)

export default component.exports